import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../models/user';
import {Farmer} from '../models/farmer';
import {AnalyticsModel} from '../models/analytics-model';
import {ConnectionService} from 'ng-connection-service';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/gsb/spianalytics/runQuery/2';

@Injectable()
export class NavigatorUtils {

  adresseIp: string;
  deviceInfo = null;

  constructor(private http: HttpClient) {
    this.adresseIp ='0.0.0.0';
  }

  deviseType(){
  }


  getDeviceInfo() { return this.deviceInfo; }

  //Get IP Adress using http://freegeoip.net/json/?callback
  getIpAddress() {
    return this.http
      .get('https://jsonip.com');
  }


}
